import Event from "common/event";
import * as _ from "lodash";
import marketScheduleService, { MarketHoliday, MarketScheduleItem } from "./marketScheduleService";
import { Dispatch } from "redux";

export class MarketScheduleLoaded extends Event {
    constructor(public commodityGroupId: number, public marketSchedule: MarketScheduleItem[]) {
        super(MarketScheduleLoaded.EventName);
    }

    public static EventName: string = "market-schedule/loaded";
}

export class MarketHolidaysLoaded extends Event {
    constructor(public commodityGroupId: number, public marketHolidays: MarketHoliday[]) {
        super(MarketHolidaysLoaded.EventName);
    }

    public static EventName: string = "market-holidays/loaded";
}

/* We're currently using the same market schedule for all commodity groups.
    If this is a new commodity group and doesn't need a different schedule, update the magic number */
const MaxCommodityGroupId = 5;

export async function loadMarketSchedule(dispatch: Dispatch) {
    const marketSchedule = await marketScheduleService.listSchedule(7); //Hard-code for now, until we have different schedules
    _.range(MaxCommodityGroupId).forEach(m => dispatch(new MarketScheduleLoaded(m + 1, marketSchedule).toObject()));
}

export async function loadMarketHolidays(dispatch: Dispatch) {
    const marketHolidays = await marketScheduleService.listHolidays(7); //Hard-code for now, until we have different schedules
    _.range(MaxCommodityGroupId).forEach(m => dispatch(new MarketHolidaysLoaded(m + 1, marketHolidays).toObject()));
}